import script from "./Vimg.vue?vue&type=script&setup=true&lang=js"
export * from "./Vimg.vue?vue&type=script&setup=true&lang=js"

import "./Vimg.vue?vue&type=style&index=0&id=c2b47320&lang=css"

const __exports__ = script;

export default __exports__